export const environment = {
  enableSmallDV: true,
  production: false,
  apiUrl: 'https://bc.digitalacceleratorplatform.com/dev/api/ux',
  apiKey: '95f74103976946c888ddafb28d5ee8d4',
  validationApiUrl: 'https://bc.digitalacceleratorplatform.com/dev/api/validation',
  validationApiKey: 'b3ea8c287b894254bd91ac31cf2e9860',
  parentOrigin: 'https://www.interconnector.de/',
  awsLocationApiKey:
    'v1.public.eyJqdGkiOiI1M2RmMzExZi03NDAxLTQ2ZjYtYmNiZS1mOGU3NTM1MjM2Y2YifV0FRgrIESwX-xYXP6oH4aDRcHai--tp5Gkt5oroKUfigM5TwMfPTuF75_ldynj4n36A4apKXVbznXeGtGSshWzpaQyBp6gy689yAAZyxDE4jLlQKLbqFEQhXBXZenLf0q1hgkJ_jH-9y6x0xkzeRNiL0jPS9nj8m_zYda9usYvHjqEtzDpVraq7ckPRKLXfgTblMqtMhIEyNv1BdySpSQcyCzwvCVj8GgsW1oCCwqLFLY5HkCuBV7v2ICCJgk4Onl0SkibNg4r7mxWQhYB64obUPf8wJ4Py5WhP4TXd7IVs6RdmLtGg5jdryG78mRcHtHL7D90my-PQj6OzIBn53QY.Y2MzMTcwNWYtZTgwMy00NGZlLWFiNGItNzVkMDFmMDM0Nzcy',
}
